import { Component } from '@angular/core';
import { StatsService } from 'src/app/core/services/stats.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/helpers/date-formats';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ValidadoresService } from '../../../../core/services/validadores.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { ObjetoAutomaticas } from 'src/app/models/objetoAutomaticas';


registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@Component({
  selector: 'app-procesadas-robot-docs',
  templateUrl: './procesadasRobot.component.html',
  styleUrls: ['./procesadasRobot.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class ProcesadasRobotComponent {

  filtro: FormGroup;
  loading: boolean;
  loadingModal: boolean;
  mostrarError: boolean;
  mostrarListado: boolean;
  datosInforme: ObjetoAutomaticas[] = [];
  documentoSeleccionado: ObjetoAutomaticas = null;
  viewerConfig: any;
  totalProcesadasAuto: number = 0;


  constructor(
    private statsService: StatsService,
    private fb: FormBuilder,
    private validadores: ValidadoresService,
    private toastr: ToastrService
  ) {
    this.loading = false;
    this.mostrarError = false;
    this.mostrarListado = false;

    this.filtro = this.fb.group({
      idDoc: [''],
      fecha: ['', [this.validadores.fechaNoAdecuada]],
      principal: [''],
      secundario: [''],
    });

    this.viewerConfig = {
      btnClass: 'default', // The CSS class(es) that will apply to the buttons
      zoomFactor: 0.1, // The amount that the scale will be increased by
      containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
      wheelZoom: true, // If true, the mouse wheel can be used to zoom in
      allowFullscreen: false, // If true, the fullscreen button will be shown, allowing the user to entr fullscreen mode
      allowKeyboardNavigation: true, // If true, the left / right arrow keys can be used for navigation
      btnIcons: { // The icon classes that will apply to the buttons. By default, font-awesome is used.
        zoomIn: 'fa fa-plus',
        zoomOut: 'fa fa-minus',
        rotateClockwise: 'fa fa-repeat',
        rotateCounterClockwise: 'fa fa-undo',
        next: 'fa fa-arrow-right',
        prev: 'fa fa-arrow-left',
        fullscreen: 'fa fa-arrows-alt',
      },
      btnShow: {
        zoomIn: true,
        zoomOut: true,
        rotateClockwise: false,
        rotateCounterClockwise: false,
        next: false,
        prev: false
      }
    };
  }

  get fechaNoValida() {
    return this.filtro.get('fecha').invalid;
  }

  private GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  SetFechaString(date: number): string {
    let resultado: string = "";

    if (Number.isNaN(date) == true || date == undefined || date == null) {
      return "";
    }

    if (date == 0) {
      return "";
    }

    let dia: number = 0;
    let mes: number = 0;
    let ano: number = 0;

    ano = this.redondearExp(date / 10000, 0);
    date = date - (ano * 10000);
    mes = this.redondearExp(date / 100, 0);
    dia = date - (mes * 100);

    if (ano == 0 || mes == 0 || dia == 0) {
      return "";
    }

    resultado = dia.toString().padStart(2, "0") + "/" + mes.toString().padStart(2, "0") + "/" + ano.toString();

    return resultado;
  }

  setHoraString(hora: number): string {
    var cadena = "";
    if (Number.isNaN(hora) == true || hora == undefined || hora == null) {
      return "";
    }
    if (hora == 0) {
      return "";
    }

    if (hora < 1000) {
      cadena = "00:0" + hora.toString().substr(0, 1) + ":" + hora.toString().substr(1);
    }
    if (hora > 1000 && hora < 10000) {
      cadena = "00:" + hora.toString().substr(0, 2) + ":" + hora.toString().substr(2);
    }
    if (hora > 10000 && hora < 100000) {
      cadena = "0" + hora.toString().substr(0, 1) + ":" + hora.toString().substr(1, 2) + ":" + hora.toString().substr(3);
    }
    if (hora > 100000) {
      cadena = hora.toString().substr(0, 2) + ":" + hora.toString().substr(2, 2) + ":" + hora.toString().substr(4);
    }

    return cadena;
  }

  private toExp(numero: Number, digitos: number): number {
    let arr = numero.toString().split("e");
    let mantisa = arr[0], exponente = digitos;
    if (arr[1]) exponente = Number(arr[1]) + digitos;
    return Number(mantisa + "e" + exponente.toString());
  }

  private redondearExp(numero: number, digitos: number, masEspaciado: boolean = false): number {

    let absNumero = Math.abs(numero);
    let signo = Math.sign(numero);

    if (masEspaciado) {
      let n = Math.floor(Math.log2(absNumero));
      let spacing = Math.pow(2, n) * Number.EPSILON;
      if (spacing < Math.pow(10, -digitos - 1)) {
        absNumero += spacing;
      }
    }

    let entero = Math.round(this.toExp(absNumero, digitos));
    return signo * this.toExp(entero, -digitos);
  }

  fechaChange($event) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    let format = 'dd/mm/yy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }

      }
    }

    this.filtro.patchValue({
      fecha: resultado
    });
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  private isDecimal(numero) {
    if (typeof numero === 'undefined') {
      return false;
    } else {
      numero = Math.abs(numero);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(numero)) {
      return true;
    }
    else {
      return false;
    }
  }


  VisualizarDatos(idDoc: string, fecha: string, secundario: string, principal: string) {
    this.loading = true;
    this.mostrarListado = false;
    this.mostrarError = false;
    this.datosInforme = [];
    var nuevoID = 0;
    var nuevaFecha = 0;

    if (!fecha && !idDoc) {
      alert("Se debe de indicar al menos una fecha o un ID de documento");
      this.mostrarListado = false;
      this.datosInforme = [];
      this.loading = false;
      this.mostrarError = true;
      return;
    }

    if (fecha != "0" && fecha.trim() != "") { nuevaFecha = this.GetFechaInteger(fecha); }
    if (idDoc != "0" && idDoc.trim() != "") { nuevoID = parseInt(idDoc); }

    this.statsService.obtenerDatosFacturasProcesadasRobot(
      nuevoID,
      nuevaFecha,
      (secundario.trim() == "") ? secundario = "vacio" : secundario.toUpperCase(),
      (principal.trim() == "") ? principal = "vacio" : principal.toUpperCase()

    ).subscribe(datos => {

      console.log(datos);
      this.datosInforme = datos;
      this.totalProcesadasAuto = this.datosInforme.length;

      this.datosInforme = this.datosInforme
        .sort(function (a, b) {
          if (b.principal > a.principal) { return -1; }
          if (b.principal < a.principal) { return 1; }
          if (b.principal == a.principal) {
            if (b.secundario > a.secundario) { return -1; }
            if (b.secundario < a.secundario) { return 1; }
            if (b.secundario == a.secundario) {
              return 0;
            }
          }
        });

      this.loading = false;
      this.mostrarListado = true;

    }, (error) => {

      console.log(error);
      this.mostrarListado = false;
      this.datosInforme = [];
      this.loading = false;
      this.mostrarError = true;
    });
  }

  convertThousandsFixed(number: any, digits) {

    if (typeof number === 'undefined') {
      number = 0.0;
    }

    if (this.isDecimal(number) === true) {
      number = parseFloat((Math.round(number * 100) / 100).toString()).toFixed(2);

      number = number.toString().replace('.', ',');
    }

    var value = number.toString().split('.').join('');
    var numbers = value.split(',');
    var enter = numbers[0];
    var new_number = '';

    var amount = enter.toString();
    amount = amount.split('').reverse();
    var output = '';
    for (var i = 0; i <= amount.length - 1; i++) {
      output = amount[i] + output;
      if ((i + 1) % 3 === 0 && (amount.length - 1) !== i) output = '.' + output;
    }

    if (digits !== '0') {

      if (numbers.length === 1) {
        if (numbers[0] === '') {
          new_number = output;
        } else {
          new_number = output + ',00';
        }
      } else {
        if (numbers[1] === '') {
          new_number = output + ',00';
        } else {
          if (numbers[1].substring(0, 2).length === 1) {
            new_number = output + ',' + numbers[1].substring(0, 1) + '0';
          } else {
            new_number = output + ',' + numbers[1].substring(0, digits);
          }
        }
      }
      if (new_number.substring(0, 1) === '-' && new_number.substring(1, 2) === '.') {
        new_number = new_number.replace('.', '');
      }
      if (new_number === '0,0000') {
        new_number = '0,00';
      }
    } else {
      new_number = output;
      if (numbers[1] !== undefined) {
        new_number = new_number + ',' + numbers[1];
      }
    }

    if (digits === '0') {
      numbers = new_number.split(',');
      if (Number(numbers[1]) === 0) {
        new_number = numbers[0];
      }
    }

    return new_number;
  }

  mostrarDetalle(documento: ObjetoAutomaticas) {

    this.documentoSeleccionado = null;

    this.statsService.cargarPreviewDoc(documento).subscribe(resultado => {
      this.documentoSeleccionado = resultado;
    });

    const botonModal = document.getElementById("botonModalPreviewDocumento") as HTMLElement;
    botonModal.click();
  }

  cerrarPrevisualizacionDOC() {

    const botonModalCerrar = document.getElementById("cerradoModalPreview") as HTMLElement;
    botonModalCerrar.click();
  }



}
